// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__23Mm4","row":"ProcedureTreatmentSummary_row__3OLEK"};